const LIST_SUB_FIELDS = ['examples_valid', 'examples_invalid', 'search_terms', 'allowed_values'];

interface Props {
  fieldName: string;
  subField: string;
  currentValue: string | null;
  proposedValue: string;
  /** If true, labels are in past tense (applied result vs pending proposal) */
  applied?: boolean;
}

function formatSubField(subField: string): string {
  switch (subField) {
    case 'notes': return 'Notes';
    case 'format': return 'Format';
    case 'description': return 'Description';
    case 'search_terms': return 'Termes de recherche';
    case 'allowed_values': return 'Valeurs permises';
    case 'examples_valid': return 'Exemples valides';
    case 'examples_invalid': return 'Exemples invalides';
    default: return subField;
  }
}

export function FieldDefDiff({ fieldName, subField, currentValue, proposedValue, applied = false }: Props) {
  const isList = LIST_SUB_FIELDS.includes(subField);

  const leftLabel = applied
    ? (isList ? 'Était (liste)' : 'Était')
    : (isList ? 'Actuel (liste)' : 'Actuel');

  const rightLabel = applied
    ? (isList ? 'Ajouté' : 'Changé pour')
    : (isList ? 'À ajouter' : 'Proposé');

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-4">
      <div className="flex items-center gap-3 mb-3">
        <span className="font-semibold text-gray-900">{fieldName}</span>
        <span className="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-indigo-100 text-indigo-700">
          {formatSubField(subField)}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <div>
          <p className="text-xs font-medium text-gray-500 mb-1 uppercase">{leftLabel}</p>
          <div className={`rounded p-3 text-sm font-mono whitespace-pre-wrap ${
            isList
              ? 'bg-gray-50 border border-gray-200 text-gray-800'
              : 'bg-red-50 border border-red-200 text-red-800 line-through'
          }`}>
            {currentValue || '—'}
          </div>
        </div>
        <div>
          <p className="text-xs font-medium text-gray-500 mb-1 uppercase">{rightLabel}</p>
          <div className="bg-green-50 border border-green-200 rounded p-3 text-sm font-mono whitespace-pre-wrap text-green-800">
            {proposedValue}
          </div>
        </div>
      </div>
    </div>
  );
}
